module.exports = __webpack_public_path__ + "media/images/flags/kr-4d72b50ae057f4f02a2a989854bd139e.svg";